import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import './ProgramChartFilters.scss'
import { SelectField } from 'discada/dist/Form'
import { FilterGroup } from 'components/widgets/Filter'

import * as QS from 'selectors/quoteSelectors'
import { SCENARIOS } from './ProgramChart'

let kz = Object.keys

export function ProgramChartFilters(props) {
  let {
      className,
      setScenario,
      scenarioKey,
      filterGroups,
      toggleFilter,
    } = props,
    inline = true

  return (
    <div className={c('program-chart-filters', className)}>
      <SelectField
        inline={inline}
        size="small"
        className="axis-select x-axis-select"
        value={scenarioKey}
        onChange={({ target }) => setScenario(target.value)}
      >
        {kz(SCENARIOS).map(k => (
          <option key={k} value={k}>
            Scenario: {SCENARIOS[k].label}
          </option>
        ))}
      </SelectField>

      {kz(filterGroups).map(k => (
        <FilterGroup
          key={k}
          label={filterGroups[k].label}
          toggleFilter={f => toggleFilter(k, f.value)}
          filters={filterGroups[k].filterVals}
          expanded
        />
      ))}
    </div>
  )
}

function mapStateToProps(state, op) {
  return { ...op, ...QS.getProgramChartFilterProps(state, op) }
}

export default connect(mapStateToProps)(ProgramChartFilters)
